import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import * as Sentry from '@sentry/react'
import { config, isProduction } from './config/env.js'

if(isProduction) {
  Sentry.init({
    dsn: config.sentryDsn,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  })
}

// The update notifier appends a `_` cache-buster when forcing a hard refresh;
// drop it from the URL after load so it doesn't linger or get bookmarked.
try {
  const cleanUrl = new URL(window.location.href)
  if (cleanUrl.searchParams.has('_')) {
    cleanUrl.searchParams.delete('_')
    window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash)
  }
} catch {
  // no-op
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
